const initialState = {
  interval_ids: []
}

const globalInerval = (state = initialState, action) => {
  switch (action.type) {
    case "G_INTERVAL":
      return { ...state, interval_ids: action?.val === "clear" ? [] : [...state.interval_ids, action?.val] }
    default:
      return state
  }
}

export default globalInerval
